<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/blackboard_icon.png" alt="칠판 아이콘">
        <div class="text_box">
            <span>스마트 칠판</span>
        </div>
    </div>
</div>